export const videoType = { 'video/mp4': ['.mp4', '.MP4'] }
export const ImageType = {
  'image/jpeg': [],
  'image/png': []
}